import React from 'react';
import 'rxjs/add/operator/debounceTime';
import {Subject} from "rxjs/Subject";
import {searchLoading, searchString, setSearchResult, updateSearchParams} from "../../redux/action/search_actions";
import {connect} from "react-redux";
import {push} from "react-router-redux";
import {queryParam} from "../../util/QueryParam";

class SearchInputContainer extends React.Component {

  searchInput;

  constructor(props) {
    super(props);

    this.state = {
      search: this.props.initialValue || null
    };

    this.inputSource = new Subject();
    this.inputObservable = this.inputSource
      .asObservable()
      .debounceTime(500);

    this.inputObservable
      .subscribe(event => {
        const search = [];
        const quotes = event.split('"');

        for(let i = 0; i < quotes.length; i++){
          if(i % 2 === 1 && quotes[i].length > 0){
            search.push(quotes[i].trim());
            continue;
          }

          const values = quotes[i].split(' ');
          for(let j = 0; j < values.length; j++ ){
            if(values[j].length > 0){
              search.push(values[j].trim());
            }
          }
        }

        this.props.setSearchString(search.join('+'));

        if( this.props.updateUrl )
          queryParam.setParams([{key: 'v', value: event}]);

        this.props.searchLoading(true);

        this.props.wpapi
          .search()
          .create({'search': search})
          .then((function (response){

            const result = {};
            result[this.props.resultPath] = response.products || [];

            this.props.setSearchResult(result);
            this.props.searchLoading(false);

          }).bind(this))
      });


    if(typeof this.props.reset === 'function')
      this.props.reset(this.reset);

    if( this.props.search_param && this.props.search_param !== this.state.search ){
      this.setState(
        {
          search: this.props.search_param
        },
        () => {
          this.inputSource.next(this.props.search_param);
        }
      );
    }

    this.handleChange     = this.handleChange.bind(this);
    this.reset            = this.reset.bind(this);
  }

  handleChange(event) {
    this.setState({search: event.target.value});
    this.inputSource.next(event.target.value);
  }

  reset(){
    this.setState({ search: '' });

    if(this.searchInput)
      this.searchInput.value = '';
  }

  componentWillReceiveProps(nextProps){
    if( this.props.updateFromParamChange
        && nextProps.search_param
        && nextProps.search_param !== this.state.search
        && ( this.searchInput !== document.activeElement || typeof this.state.search !== 'string' )
        && !this.props.loading ){
      this.setState(
        {
          search: nextProps.search_param
        },
        () => {
          this.inputSource.next(nextProps.search_param);
        }
      );
    }
  }

  render(){
    return (
      <input className={"form-control " + this.props.className }
             placeholder="Search Products" type="text"
             value={this.state.search || ''}
             onClick={ () => this.state.search && this.searchInput.setSelectionRange(0, this.state.search.length) }
             onChange={this.handleChange}
             ref={ el => {
               this.searchInput = el;
               if( typeof this.props.innerRef === 'function')
                this.props.innerRef(el);
             } } />
    );
  }

}

export const SearchInput = connect(
  state => ({
    wpapi: state.WPAPI.instance,
    search_param: state.search.param,
    loading: state.search.loading,
  }),
  dispatch => ({
    changeLocation: location => dispatch(push(location)),
    setSearchResult: result => dispatch(setSearchResult(result)),
    searchLoading: loading => dispatch(searchLoading(loading)),
    setSearchString: s_str => dispatch(searchString(s_str)),
    updateSearchParams: param => dispatch(updateSearchParams(param))
  })
)(SearchInputContainer);



// WEBPACK FOOTER //
// ./src/components/search-bar/SearchInput.js